import { DataInterfaceType } from '../../gamma-api';
import { AI_ACTIONS_PATH_BASE, CHAT_AGENTS_PATH_BASE } from '../constants/agents';

export const getFoldersPath = (): string => {
  return `/folders`;
};

export const getProvidersPath = (): string => {
  return `/providers`;
};

export const getApiKeysPath = (): string => {
  return `/keys`;
};

export const getMoreItemsPath = (): string => {
  return `/more`;
};

export const getFolderPath = (folderId?: string): string => {
  return `${getFoldersPath()}/${folderId || '-'}`;
};

export const getChatAgentsPath = (folderId?: string): string => {
  return `${getFolderPath(folderId)}/${CHAT_AGENTS_PATH_BASE}`;
};

export const getChatAgentPath = (folderId?: string, agentId?: string, tabKey?: string): string => {
  const result = `${getChatAgentsPath(folderId)}/${agentId || '-'}`;
  return tabKey ? `${result}/${tabKey}` : result;
};

export const getApiAgentsPath = (folderId?: string): string => {
  return `${getFolderPath(folderId)}/${AI_ACTIONS_PATH_BASE}`;
};

export const getApiAgentPath = (folderId?: string, agentId?: string, tabKey?: string): string => {
  const result = `${getApiAgentsPath(folderId)}/${agentId || '-'}`;
  return tabKey ? `${result}/${tabKey}` : result;
};

export const getAgentsPath = (interfaceType?: DataInterfaceType, folderId?: string): string => {
  return interfaceType === DataInterfaceType.Api ? getApiAgentsPath(folderId) : getChatAgentsPath(folderId);
};

export const getAgentPath = (
  interfaceType?: DataInterfaceType,
  folderId?: string,
  agentId?: string,
  tabKey?: string
): string => {
  return interfaceType === DataInterfaceType.Api
    ? getApiAgentPath(folderId, agentId, tabKey)
    : getChatAgentPath(folderId, agentId, tabKey);
};

export const getAgentToolsetsPath = (
  interfaceType?: DataInterfaceType,
  folderId?: string,
  agentId?: string
): string => {
  return getAgentPath(interfaceType, folderId, agentId, 'toolsets');
};

export const getProjectsPath = (folderId?: string): string => {
  return `${getFolderPath(folderId)}/projects`;
};

export const getProjectPath = (folderId?: string, projectId?: string, tabKey?: string): string => {
  const result = `${getProjectsPath(folderId)}/${projectId || '-'}`;
  return tabKey ? `${result}/${tabKey}` : result;
};

export const getProjectSourcesPath = (folderId?: string, projectId?: string): string => {
  return getProjectPath(folderId, projectId, 'sources');
};

export const getProjectSourcePath = (folderId?: string, projectId?: string, sourceId?: string): string => {
  return `${getProjectSourcesPath(folderId, projectId)}/${sourceId || '-'}`;
};

export const getToolkitsPath = (folderId?: string): string => {
  return `${getFolderPath(folderId)}/toolkits/elma365`;
};

export const getToolkitPath = (folderId?: string, toolsetId?: string): string => {
  return `${getToolkitsPath(folderId)}/${toolsetId || '-'}`;
};

export const getToolkitToolPath = (folderId?: string, toolsetId?: string, toolId?: string, tabKey?: string): string => {
  const result = `${getToolkitPath(folderId, toolsetId)}/tools/${toolId || '-'}`;
  return tabKey ? `${result}/${tabKey}` : result;
};
